import React, { Component, useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import auth from "../../Services/authService";
import config from "../../config.json";
import http from "../../Services/httpService";
import { getFieldData } from "../../Services/appService";
import { useDispatch, useSelector } from "react-redux";
import {
  getCurrentUser,
  getLoggedUserDetails,
  loadUserDetails,
} from "../../app/store/auth";
import {
  getComponentUpdateStatus,
  getComponentUserStatus,
  getPermission,
  getToolsCount,
  loadComponentUserStatus,
  loadPermissions,
  loadToolsCount,
} from "../../app/store/tools";
import {
  getAppTasks,
  getCandidateAppAllTasks,
  getCandidateApps,
  loadAppRuningTasks,
  loadCandidateAppAllTasks,
  loadCandidateApps,
} from "../../app/store/candidate";
import { getPartnerDetails, loadPartnerDetails } from "../../app/store/partner";

const Menu = () => {
  const state = {
    isSelected: null,
    currentUser: "",
    docsCount: 0,
    bcCount: 0,
    recDoc: 0,
    sentDoc: 0,
    frmLibraryDoc: 0,
    achFrmLibraryDoc: 0,
    insFrmLibraryDoc: 0,
    meetingCount: 0,
    msgCount: 0,
    poOrderCount: 0,
  };

  const c2cPhases = [
    { id: 1, wfPhase: "Application" },
    { id: 2, wfPhase: "Review" },
    { id: 3, wfPhase: "Onboarding" },
    { id: 4, wfPhase: "Time Log" },
    { id: 5, wfPhase: "Invoice" },
    { id: 6, wfPhase: "Approved" },
    { id: 7, wfPhase: "Denied" },
    { id: 8, wfPhase: "Compliance" },
  ];

  const w2Phases = [
    "Application",
    "Review",
    "Onboarding",
    "Time Log",
    "Invoice",
    "Approved",
    "Denied",
    "Compliance",
  ];

  const [entityType, setEntityType] = useState("");
  const [rptNotify, setRptNotify] = useState("");
  const [toolsCounts, setToolsCounts] = useState([]);
  const [appTasklist, setAppTasklist] = useState([]);
  const [allPhases, setAllPhases] = useState([]);
  const [taskAllPhases, setTaskAllPhases] = useState([]);
  const [rolePermission, setRolePermission] = useState([]);
  const [partnerDetails, setPartnerDetails] = useState([]);
  const [appStatus, setAppStatus] = useState(false);
  const [appApproved, setAppApproved] = useState(false);
  const [appAllTasks, setAllAppTasks] = useState([]);

  const userDetailSelector = useSelector(getLoggedUserDetails);
  const partnerDetailsSelector = useSelector(getPartnerDetails);
  const toolsCountSelector = useSelector(getToolsCount);
  const componentUserStatusSelector = useSelector(getComponentUserStatus);
  const componentUpdateStatusSelector = useSelector(getComponentUpdateStatus);
  const candidateAppsSelector = useSelector(getCandidateApps);
  const candidateAppAllTasksSelector = useSelector(getCandidateAppAllTasks);
  const appTasksSelector = useSelector(getAppTasks);
  const appPermissionDataSel = useSelector(getPermission);

  const usrType = localStorage.getItem("userType");
  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  // useEffect(() => {
  //   console.log("menu")
  //   if (currentUser?.id > 0 && !userDetailSelector) {
  //     dispatch(loadUserDetails(currentUser.id));
  //   }
  // }, []);

  useEffect(() => {
    if (userDetailSelector) {
      const entType = getFieldData(
        userDetailSelector.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );
      setEntityType(entType);
      const isSent = getFieldData(
        userDetailSelector.performerData,
        "reportingdetails",
        "isSent"
      );
      setRptNotify(isSent);
      setAppStatus(userDetailSelector?.appSubmit);
      setAppApproved(userDetailSelector?.approved > 0);

      if (userDetailSelector?.partnerid && partnerDetailsSelector == null)
        dispatch(loadPartnerDetails(userDetailSelector.partnerid))
    }
  }, [userDetailSelector]);

  useEffect(() => {
    if (currentUser?.id > 0) {
      dispatch(loadToolsCount(currentUser.id));
      if (usrType !== "candidate") dispatch(loadPermissions(currentUser.id));
      else dispatch(loadCandidateAppAllTasks(currentUser.id));
    }
  }, []);

  useEffect(() => {
    setAllAppTasks(candidateAppAllTasksSelector);
  }, [candidateAppAllTasksSelector]);

  // useEffect(() => {
  //   console.log(userDetailSelector);
  //   console.log(partnerDetailsSelector);
  //   if (userDetailSelector?.partnerid && partnerDetailsSelector == null) {
  //     dispatch(loadPartnerDetails(userDetailSelector.partnerid));
  //   }
  // }, [userDetailSelector]);

  useEffect(() => {
    // if (partnerDetailsSelector) {
    //   setPartnerDetails(partnerDetailsSelector);
    //   if (candidateAppsSelector.length === 0 && partnerDetailsSelector?.contact1?.performerid > 0)
    //     dispatch(loadCandidateApps(partnerDetailsSelector?.contact1?.performerid));
    // }
    // else {
    //   if (candidateAppsSelector.length === 0)
    //     dispatch(loadCandidateApps(currentUser.id));
    // }
    setPartnerDetails(partnerDetailsSelector);
  }, [partnerDetailsSelector]);

  useEffect(() => {
    if (appPermissionDataSel.length > 0) {
      setRolePermission(appPermissionDataSel);
    }
  }, [appPermissionDataSel]);

  // useEffect(() => {
  //   if (candidateAppsSelector.length > 0) {
  //     const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
  //     console.log(mainWorkflow)
  //     if (mainWorkflow.length > 0) {
  //       const wf = mainWorkflow[0];

  //       if (wf.type === "Candidate" && currentUser?.id > 0) {
  //         dispatch(loadAppRuningTasks(wf.oldWorkflowId, currentUser.id));
  //       } else if (partnerDetails?.contact1?.performerid > 0) {
  //         dispatch(loadAppRuningTasks(wf.oldWorkflowId, partnerDetails?.contact1?.performerid));
  //       }
  //     }
  //   }
  // }, [candidateAppsSelector, partnerDetails]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      let phs = [];

      const filterTasks = appTasksSelector
        .filter((x) => x.wiid > 0)
        .sort((a, b) => a.orderNumber - b.orderNumber);

      filterTasks.map((p, key) => {
        if (phs.findIndex((x) => x.wfPhase === p.wfPhase) === -1)
          phs.push({ id: key + 1, wfPhase: p.wfPhase });
      });
      // if (usrType !== "candidate")
      //   phs = phs.filter(x => x.wfPhase !== "Approved");
      setTaskAllPhases(phs);
      setAppTasklist(filterTasks);
    }
  }, [appTasksSelector]);

  useEffect(() => {
    if (toolsCountSelector.length > 0) {
      setToolsCounts(toolsCountSelector);
      const appObj = toolsCountSelector.filter((x) => x.key === 0);
      if (appObj.length > 0) {
        dispatch(loadComponentUserStatus(currentUser?.id, appObj[0].value));
      }
    }
  }, [toolsCountSelector]);

  const getCount = (id) => {
    if (!toolsCountSelector) return 0;
    const toolObj = toolsCountSelector.filter((x) => x.key == id);
    if (toolObj.length > 0) return toolObj[0].value;
    return 0;
  };

  const getToolCount = (id) => {
    const compObj = componentUserStatusSelector.filter((x) => x.compId === id);
    if (compObj.length > 0) {
      const unreadComps = compObj[0].unreadCompItems.split(",").sort();
      const readComps = compObj[0].compItems.split(",").sort();
      let unReadCount = 0;
      unreadComps
        .filter((x) => x !== "")
        .map((x) => {
          const rs = readComps.filter((y) => y === x);
          if (rs.length === 0) {
            unReadCount += 1;
          }
        });
      if (unReadCount === 0) {
        return (
          <span className="badge badge-pill badge-success ml-1 text-dark">
            {getCount(id)}
          </span>
        );
      } else {
        return (
          <span className="badge badge-pill badge-danger ml-1">
            {unReadCount}
          </span>
        );
      }
    } else {
      return (
        <span className="badge badge-pill badge-danger ml-1">
          {getCount(id)}
        </span>
      );
    }
  };

  useEffect(() => {
    if (componentUpdateStatusSelector) {
      dispatch(loadToolsCount(currentUser.id));
    }
  }, [componentUpdateStatusSelector]);

  const getPhaseColor = (phase) => {
    const app = [];
    const totalPhases = allPhases;
    var keyCount = 0;
    let phaseBg = "btn-wf-default";
    totalPhases.map((item) => {
      let keyNum = 5;
      if (item.wfPhase === "Application") keyNum = 1;
      if (item.wfPhase === "Review" || item.wfPhase === "Onboarding")
        keyNum = 2;
      if (item.wfPhase === "Approved") keyNum = 3;
      if (item.wfPhase === "Denied") keyNum = 4;
      if (keyNum === 5) {
        keyNum += keyCount;
        keyCount += 1;
      }

      if (item.wfPhase === phase) {
        phaseBg = `btn-wf${keyNum}-default`;
      }
    });

    return phaseBg;
  };

  const checkMenuPermission = (mid) => {
    // const { rolePermission } = this.state;
    if (!rolePermission) return;
    const user = auth.getCurrentUser();
    if (user?.type === "admin") return true;
    const mm = mid.split("_");
    let chk = false;
    if (mm[0] === "m") {
      const mR = rolePermission.filter(
        (x) => x.id === parseInt(mm[1]) && x.isChecked === true
      );
      if (mR.length > 0) {
        chk = true;
      } else {
        rolePermission
          .filter((x) => x.id === parseInt(mm[1]))
          .map((menu) => {
            const sMenu = menu.menus.filter((x) => x.isChecked === true);
            if (sMenu.length > 0) {
              chk = true;
            } else {
              menu.menus.map((ssmenu) => {
                if (ssmenu?.menus) {
                  const ssMenu = ssmenu.menus.filter(
                    (x) => x.isChecked === true
                  );
                  if (ssMenu.length > 0) {
                    chk = true;
                  }
                }
              });
            }
          });
      }
    }
    if (mm[0] === "sm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[2]))
        .map((menu) => {
          const sMenu = menu.menus.filter(
            (x) => x.id === parseInt(mm[1]) && x.isChecked === true
          );
          if (sMenu.length > 0) {
            chk = true;
          } else {
            menu.menus.map((smenu) => {
              if (smenu?.menus) {
                const ssMenu = smenu.menus.filter((x) => x.isChecked === true);
                if (ssMenu.length > 0) {
                  chk = true;
                }
              } else {
                if (smenu?.isChecked) {
                  chk = true;
                }
              }
            });
          }
        });
    }
    if (mm[0] === "ssm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[3]))
        .map((menu) =>
          menu.menus
            .filter((x) => x.id === parseInt(mm[2]))
            .map((ssmenu) => {
              if (ssmenu?.menus) {
                const ssMenu = ssmenu.menus.filter(
                  (x) => x.id === parseInt(mm[1]) && x.isChecked === true
                );
                if (ssMenu.length > 0) {
                  chk = true;
                }
              } else {
                if (ssmenu?.isChecked) chk = true;
              }
            })
        );
    }
    if (mm[0] === "sssm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[4]))
        .forEach((menu) => {
          menu.menus
            .filter((x) => x.id === parseInt(mm[3]))
            .forEach((ssmenu) => {
              ssmenu.menus
                .filter((x) => x.id === parseInt(mm[2]))
                .forEach((sssmenu) => {
                  if (sssmenu?.menus) {
                    const ssMenu = sssmenu.menus.filter(
                      (x) => x.id === parseInt(mm[1]) && x.isChecked === true
                    );
                    if (ssMenu.length > 0) {
                      chk = true;
                    }
                  } else {
                    if (sssmenu?.isChecked) chk = true;
                  }
                });
            });
        });
    }

    return chk;
  };

  return (
    <nav
      className="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white shadow-none"
      id="sidenav-main"
    >
      <div className="scrollbar-inner">
        <div className="sidenav-header d-flex align-items-center">
          <a
            className="navbar-brand"
            href="/"
            style={{ padding: "12px", marginLeft: "18px" }}
          >
            <img
              src="/assets/img/wflogoblack.png"
              className="navbar-brand-img"
              alt="Workfinity"
            />
          </a>

          <div className="ml-auto">
            <div
              className="sidenav-toggler d-none d-xl-block"
              data-action="sidenav-unpin"
              data-target="#sidenav-main"
              style={{ padding: "15px" }}
            >
              <div className="sidenav-toggler-inner">
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
                <i className="sidenav-toggler-line" />
              </div>
            </div>
          </div>
        </div>
        <div className="navbar-inner" style={{ marginTop: "-18px" }}>
          <div className="collapse navbar-collapse" id="sidenav-collapse-main">
            <ul className="navbar-nav">
              {(userDetailSelector?.performername ===
                partnerDetails?.contact1?.performername ||
                checkMenuPermission("m_1")) &&
                usrType !== "candidate" && (
                  <React.Fragment>
                    <li className="nav-item">
                      <h6
                        className="navbar-heading mb-0 btn p-2 rounded-0 text-left text-dark border-right-0"
                        style={{ border: "1px solid #ccc", fontWeight: "bold" }}
                      >
                        <i
                          className="fa fa-user-circle-o mr-2"
                          aria-hidden="true"
                        ></i>
                        Administration
                      </h6>
                    </li>
                    {(checkMenuPermission("sm_1_1") ||
                      userDetailSelector?.performername ===
                      partnerDetails?.contact1?.performername) && (
                        <li className="nav-item">
                          <NavLink
                            style={{ color: "black" }}
                            to="/ManagePartnerUsers"
                            className="nav-link"
                            title="You may add as many users to access the portal."
                          >
                            <i
                              className="fa fa-user"
                              style={{
                                minWidth: "2rem",
                                fontSize: "20px",
                                marginLeft: "-10px",
                              }}
                            ></i>
                            <span className="ml--2">Manage Users</span>
                          </NavLink>
                        </li>
                      )}
                  </React.Fragment>
                )}
              {/* {checkMenuPermission("m_2") && (
                <> */}
              <li className="nav-item">
                <h6
                  className="navbar-heading mb-0 btn p-2 rounded-0 text-left text-dark"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderTop: "1px solid #dee2e6",
                    fontWeight: "bold",
                  }}
                >
                  {/* {usrType === "candidate"
                    ? "Task Management"
                    : "Contract Management"} */}
                  <i className="fa fa-desktop mr-2" aria-hidden="true"></i>
                  Onboarding
                </h6>
              </li>
              <ul className="nav flex-column">
                <li className="nav-item">
                  <NavLink
                    style={{ color: "black" }}
                    to="/Onboarding"
                    className="nav-link stepMenu"
                  >
                    Onboarding Form{" "}
                    {appStatus ? (
                      <i className="fa fa-solid fa-check text-success ml-1"></i>
                    ) : (
                      <i className="fa fa-solid fa-times text-warning ml-1"></i>
                    )}
                  </NavLink>
                </li>
                <li className="nav-item">
                  {(userDetailSelector?.performername ===
                    partnerDetails?.contact1?.performername ||
                    usrType === "candidate" ||
                    checkMenuPermission("ssm_1_1_2")) && (
                      <NavLink
                        style={{ color: "black" }}
                        to="/ContractDocs"
                        className="nav-link stepMenu"
                      >
                        Contract Management{" "}
                        {appApproved ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        )}{" "}
                        {getToolCount(3)}
                      </NavLink>
                    )}

                  {usrType !== "candidate" && (
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        {(userDetailSelector?.performername ===
                          partnerDetails?.contact1?.performername ||
                          checkMenuPermission("sssm_1_1_1_2")) && (
                            <NavLink
                              style={{ color: "black" }}
                              to="/AchInfo"
                              className="nav-link"
                            >
                              ACH Information{" "}
                              {appApproved ? (
                                <i className="fa fa-solid fa-check text-success ml-1"></i>
                              ) : (
                                <i className="fa fa-solid fa-times text-warning ml-1"></i>
                              )}{" "}
                              {getToolCount(20)}
                            </NavLink>
                          )}
                      </li>
                      <li className="nav-item">
                        {(userDetailSelector?.performername ===
                          partnerDetails?.contact1?.performername ||
                          checkMenuPermission("sssm_2_1_1_2")) && (
                            <NavLink
                              style={{ color: "black" }}
                              to="/InsuranceInfo"
                              className="nav-link"
                            >
                              Insurance Information{" "}
                              {appApproved ? (
                                <i className="fa fa-solid fa-check text-success ml-1"></i>
                              ) : (
                                <i className="fa fa-solid fa-times text-warning ml-1"></i>
                              )}{" "}
                              {getToolCount(21)}
                            </NavLink>
                          )}
                      </li>
                    </ul>
                  )}

                  {usrType === "candidate" && entityType !== "C2C Basis" && (
                    <ul className="nav nav-sm flex-column">
                      <li className="nav-item">
                        <NavLink
                          style={{ color: "black" }}
                          to="/AchInfo"
                          className="nav-link"
                        >
                          ACH Information{" "}
                          {appApproved ? (
                            <i className="fa fa-solid fa-check text-success ml-1"></i>
                          ) : (
                            <i className="fa fa-solid fa-times text-warning ml-1"></i>
                          )}{" "}
                          {getToolCount(20)}
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
                {usrType === "candidate" && (
                  <li className="nav-item">
                    <NavLink
                      style={{ color: "black" }}
                      to="/BackgroundChecks"
                      className="nav-link stepMenu"
                    >
                      Background Checks{" "}
                      {appApproved ? (
                        <i className="fa fa-solid fa-check text-success ml-1"></i>
                      ) : (
                        <i className="fa fa-solid fa-times text-warning ml-1"></i>
                      )}{" "}
                      {getToolCount(26)}
                    </NavLink>
                  </li>
                )}

                <li className="nav-item">
                  {(userDetailSelector?.performername ===
                    partnerDetails?.contact1?.performername ||
                    usrType === "candidate" ||
                    checkMenuPermission("ssm_2_1_2")) && (
                      <NavLink
                        style={{ color: "black" }}
                        to="/OnboardingStatus"
                        className="nav-link stepMenu"
                      >
                        Check Onbording Status{" "}
                        {appApproved ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        )}
                      </NavLink>
                    )}
                </li>
                {usrType === "candidate" && (
                  <>
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/ReportingDetails"
                        className="nav-link stepMenu"
                      >
                        Reporting Details{" "}
                        {appApproved ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        )}
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/TimeLogs"
                        className="nav-link stepMenu"
                      >
                        Time Logs {entityType !== "C2C Basis" && "and Payments"}{" "}
                        {appAllTasks.filter(
                          (x) => x.loanPhase_Desc === "Time Log"
                        ).length > 0 ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        )}
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/Compliance"
                        className="nav-link stepMenu"
                      >
                        Compliance{" "}
                        {appAllTasks.filter(
                          (x) => x.loanPhase_Desc === "Compliance"
                        ).length > 0 ? (
                          <i className="fa fa-solid fa-check text-success ml-1"></i>
                        ) : (
                          <i className="fa fa-solid fa-times text-warning ml-1"></i>
                        )}
                      </NavLink>
                    </li>
                  </>
                )}

                {usrType !== "candidate" && (
                  <>
                    <li className="nav-item">
                      {(userDetailSelector?.performername ===
                        partnerDetails?.contact1?.performername ||
                        checkMenuPermission("ssm_1_2_2")) && (
                          <NavLink
                            style={{ color: "black" }}
                            to="/PartnerCandidates"
                            className="nav-link stepMenu"
                          >
                            List of Candidates{" "}
                            {appApproved ? (
                              <i className="fa fa-solid fa-check text-success ml-1"></i>
                            ) : (
                              <i className="fa fa-solid fa-times text-warning ml-1"></i>
                            )}
                          </NavLink>
                        )}
                    </li>
                    <li className="nav-item">
                      {(userDetailSelector?.performername ===
                        partnerDetails?.contact1?.performername ||
                        checkMenuPermission("ssm_1_3_2")) && (
                          <NavLink
                            style={{ color: "black" }}
                            to="/PartnerInvoices"
                            className="nav-link stepMenu"
                          >
                            Invoice and Payments{" "}
                            {appApproved ? (
                              <i className="fa fa-solid fa-check text-success ml-1"></i>
                            ) : (
                              <i className="fa fa-solid fa-times text-warning ml-1"></i>
                            )}
                          </NavLink>
                        )}
                    </li>
                  </>
                )}
              </ul>
              {allPhases.map((p) => {
                return (
                  <li className="nav-item">
                    {(userDetailSelector?.performername ===
                      partnerDetails?.contact1?.performername ||
                      usrType === "candidate" ||
                      (p.wfPhase === "Onboarding"
                        ? checkMenuPermission("sm_1_2")
                        : p.wfPhase === "Time Log"
                          ? checkMenuPermission("sm_2_2")
                          : p.wfPhase === "Invoice"
                            ? checkMenuPermission("sm_3_2")
                            : true)) && (
                        <>
                          {/* <h3 className="nav-link active">
                          <div aria-label={`${p.wfPhase}`} className={`${getPhaseColor(p.wfPhase)} rounded border wf-box`}></div>
                          {p.wfPhase}
                        </h3> */}
                          <div className="collapse show" id="navbar-manageCip">
                            <ul className="nav flex-column">
                              {appTasklist
                                .filter((x) => x.wfPhase === p.wfPhase)
                                .map((tsk, key) => {
                                  if (tsk.taskName === "Onboarding/Enrollment") {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/Onboarding"
                                          className="nav-link stepMenu"
                                        >
                                          {/* {tsk.taskName} */} Onboarding Form
                                        </NavLink>
                                      </li>
                                    );
                                  } else if (
                                    tsk.taskName === "Contract Management"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        {(userDetailSelector?.performername ===
                                          partnerDetails?.contact1
                                            ?.performername ||
                                          usrType === "candidate" ||
                                          checkMenuPermission("ssm_1_1_2")) && (
                                            <NavLink
                                              style={{ color: "black" }}
                                              to="/ContractDocs"
                                              className="nav-link stepMenu"
                                            >
                                              {tsk.taskName} {getToolCount(3)}
                                            </NavLink>
                                          )}

                                        {usrType !== "candidate" && (
                                          <ul className="nav nav-sm flex-column">
                                            <li className="nav-item">
                                              {(userDetailSelector?.performername ===
                                                partnerDetails?.contact1
                                                  ?.performername ||
                                                checkMenuPermission(
                                                  "sssm_1_1_1_2"
                                                )) && (
                                                  <NavLink
                                                    style={{ color: "black" }}
                                                    to="/AchInfo"
                                                    className="nav-link"
                                                  >
                                                    ACH Information
                                                    {getToolCount(20)}
                                                  </NavLink>
                                                )}
                                            </li>
                                            <li className="nav-item">
                                              {(userDetailSelector?.performername ===
                                                partnerDetails?.contact1
                                                  ?.performername ||
                                                checkMenuPermission(
                                                  "sssm_2_1_1_2"
                                                )) && (
                                                  <NavLink
                                                    style={{ color: "black" }}
                                                    to="/InsuranceInfo"
                                                    className="nav-link"
                                                  >
                                                    Insurance Information
                                                    {getToolCount(21)}
                                                  </NavLink>
                                                )}
                                            </li>
                                          </ul>
                                        )}

                                        {usrType === "candidate" &&
                                          entityType !== "C2C Basis" && (
                                            <ul className="nav nav-sm flex-column">
                                              <li className="nav-item">
                                                <NavLink
                                                  style={{ color: "black" }}
                                                  to="/AchInfo"
                                                  className="nav-link"
                                                >
                                                  ACH Information
                                                  {getToolCount(20)}
                                                </NavLink>
                                              </li>
                                            </ul>
                                          )}
                                      </li>
                                    );
                                  } else if (
                                    tsk.taskName === "Background Check"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/BackgroundChecks"
                                          className="nav-link stepMenu"
                                        >
                                          {tsk.taskName} {getToolCount(26)}
                                        </NavLink>
                                      </li>
                                    );
                                  } else if (tsk.taskName === "Review") {
                                    return (
                                      <li className="nav-item">
                                        {(userDetailSelector?.performername ===
                                          partnerDetails?.contact1
                                            ?.performername ||
                                          usrType === "candidate" ||
                                          checkMenuPermission("ssm_2_1_2")) && (
                                            <NavLink
                                              style={{ color: "black" }}
                                              to="/OnboardingStatus"
                                              className="nav-link stepMenu"
                                            >
                                              Check Onbording Status
                                            </NavLink>
                                          )}
                                      </li>
                                    );
                                  } else if (
                                    tsk.taskName === "Reporting Details"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/ReportingDetails"
                                          className="nav-link stepMenu"
                                        >
                                          {tsk.taskName}
                                        </NavLink>
                                      </li>
                                    );
                                  } else if (
                                    tsk.wfPhase === "Time Log" &&
                                    usrType === "candidate"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/TimeLogs"
                                          className="nav-link stepMenu"
                                        >
                                          {tsk.taskName}
                                        </NavLink>
                                      </li>
                                    );
                                  } else if (
                                    tsk.wfPhase === "Time Log" &&
                                    usrType !== "candidate"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        {(userDetailSelector?.performername ===
                                          partnerDetails?.contact1
                                            ?.performername ||
                                          checkMenuPermission("ssm_1_2_2")) && (
                                            <NavLink
                                              style={{ color: "black" }}
                                              to="/PartnerCandidates"
                                              className="nav-link stepMenu"
                                            >
                                              {tsk.taskName}
                                            </NavLink>
                                          )}
                                      </li>
                                    );
                                  } else if (
                                    tsk.wfPhase === "Invoice" &&
                                    usrType !== "candidate"
                                  ) {
                                    return (
                                      <li className="nav-item">
                                        {(userDetailSelector?.performername ===
                                          partnerDetails?.contact1
                                            ?.performername ||
                                          checkMenuPermission("ssm_1_3_2")) && (
                                            <NavLink
                                              style={{ color: "black" }}
                                              to="/PartnerInvoices"
                                              className="nav-link stepMenu"
                                            >
                                              {tsk.taskName}
                                            </NavLink>
                                          )}
                                      </li>
                                    );
                                  } else if (tsk.wfPhase === "Compliance") {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/Compliance"
                                          className="nav-link stepMenu"
                                        >
                                          {tsk.taskName}
                                        </NavLink>
                                      </li>
                                    );
                                  } else {
                                    return (
                                      <li className="nav-item">
                                        <NavLink
                                          style={{ color: "black" }}
                                          to="/"
                                          className="nav-link stepMenu"
                                        >
                                          {tsk.taskName}
                                        </NavLink>
                                      </li>
                                    );
                                  }
                                })}
                            </ul>
                          </div>
                        </>
                      )}
                  </li>
                );
              })}

              <li className="nav-item">
                <h6
                  className="navbar-heading mb-0 btn p-2 rounded-0 text-left text-dark"
                  style={{
                    borderBottom: "1px solid #dee2e6",
                    borderTop: "1px solid #dee2e6",
                    fontWeight: "bold",
                  }}
                >
                  <i className="fa fa-wrench mr-2" aria-hidden="true"></i>Tools
                </h6>
              </li>
              <li className="nav-item">
                {/* <h3>
                  <div className={`btn-default rounded border shadow-none wf-box`}></div>
                  <i className="fa fa-wrench" aria-hidden="true"></i>
                </h3> */}
                <div className="collapse show mt--2" id="navbar-manageCip">
                  <ul className="nav flex-column">
                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/IndividualMsg"
                        className="nav-link stepMenu"
                        title="Use this feature for to and fro communication"
                      >
                        Message(s)
                        {getToolCount(9)}
                      </NavLink>
                    </li>

                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/FormLibrary"
                        className="nav-link stepMenu"
                        title="Repository of fillable forms to be completed."
                      >
                        Forms
                        {getToolCount(22)}
                      </NavLink>
                    </li>

                    <li className="nav-item">
                      <NavLink
                        style={{ color: "black" }}
                        to="/SentDocs"
                        className="nav-link stepMenu"
                        title="View history of documents sent and received."
                      >
                        Document History
                        {getToolCount(2)}
                      </NavLink>
                    </li>

                    <li className="nav-item">
                      {entityType !== "C2C Basis" && (
                        <>
                          <NavLink
                            style={{ color: "black" }}
                            to="/ComplianceRpt"
                            className="nav-link stepMenu"
                            title="In this section you will receive yearly compliance document (1099-NEC)."
                          >
                            Compliance {getToolCount(25)}
                          </NavLink>
                          <NavLink
                            style={{ color: "black" }}
                            to="/CustomReport"
                            className="nav-link stepMenu"
                            title="View standard reports."
                          >
                            Reports
                          </NavLink>
                        </>
                      )}

                      <NavLink
                        style={{ color: "black" }}
                        to="/ScheduleMeeting"
                        className="nav-link stepMenu"
                        title="In the event any appointment is scheduled you will accept the same in this section."
                      >
                        Schedule Appointments
                        {getToolCount(11)}
                      </NavLink>
                      <NavLink
                        style={{ color: "black" }}
                        to="/SurveyFeedback"
                        className="nav-link stepMenu"
                        title="Complete the surveys as part of total customer satisfaction."
                      >
                        Surveys
                      </NavLink>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
